import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { getAnalyticsLanguageInfo } from 'src/utils/analytics/getAnalyticsLanguageInfo';
import { getAnalyticsUserInfo } from 'src/utils/analytics/getAnalyticsUserInfo';
import { CollapsibleCard } from 'src/components';
import { useUserContext } from 'src/context/user';
import { msgs } from './messages';
import * as S from './styles';

const questions = [
  { question: msgs.question5, answer: msgs.answer5 },
  { question: msgs.question1, answer: msgs.answer1 },
  { question: msgs.question2, answer: msgs.answer2 },
  { question: msgs.question3, answer: msgs.answer3 },
  { question: msgs.question4, answer: msgs.answer4 },
];

export const FAQSection: FC = () => {
  const intl = useIntl();
  const { user } = useUserContext();

  const collapsibleCardsData = useMemo(
    () =>
      questions.map(({ question, answer }) => {
        const header = intl.formatMessage(question);

        return {
          key: question.id,
          description: intl.formatMessage(answer),
          header,
          onAccordionToggle: (isOpen: boolean) => {
            if (isOpen) {
              window.dataLayer.push({
                event: 'click_accordion',
                page_screen_type: 'Subscriptions',
                page_screen_name: 'Subscriptions',
                ...getAnalyticsLanguageInfo(intl),
                ...getAnalyticsUserInfo(user),
                click_area: 'Content',
                click_path: header,
              });
            }
          },
        };
      }),
    [user, intl],
  );

  return (
    <S.SectionWrapper>
      <S.Heading>{intl.formatMessage(msgs.popularQuestions)}</S.Heading>

      <S.Questions>
        {collapsibleCardsData.map(({ description, header, key, onAccordionToggle }) => (
          <CollapsibleCard
            description={description}
            header={header}
            key={key}
            onAccordionToggle={onAccordionToggle}
          />
        ))}
      </S.Questions>
    </S.SectionWrapper>
  );
};
